import http from "@/config/http";

/*************** <ACTIVITIES> *********************/
export const getActivity = async (id) => http.get(`v1/users/${id}/activities`);

export const createActivity = async (data) => http.post(`v1/activity`, data);

export const highlightsActivity = async (id) => http.get(`v1/users/${id}/highlights`);

/*************** <ACTIVITIES/> *********************/